// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__c5rEb","error":"Textarea_error__1mnAD","readonly":"Textarea_readonly__1ntEM","disabled":"Textarea_disabled__2vyqC"};